<template>
  <div class="cargo-button-group-slider">
    <div class="wrapper" :class="[isScrollable?'is-scrollable':'']">
      <span v-if="isScrollable" class="pre" @click="handlePre"><i class="el-icon-caret-left" /></span>
      <span v-if="isScrollable" class="next" @click="handleNext"><i class="el-icon-caret-right" /></span>
      <div ref="scroller" class="scroller" :style="!isScrollable?`text-align:${align}`:''">
        <div ref="btn-group" class="button-group" :style="`left:${offsetWidth}px`">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CargoButtonGroupSlider',
  props: {
    align: {
      type: String,
      default: () => 'left'
    }
  },
  data() {
    return {
      isScrollable: false,
      offsetWidth: 0,
      timer: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.resizeHandler()
    }, 500)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resizeHandler() {
      const scroller = this.$refs.scroller
      const btnGroup = this.$refs['btn-group']
      if (btnGroup.offsetWidth > scroller.offsetWidth) {
        if (!this.isScrollable) {
          this.isScrollable = true
        }
      } else {
        this.isScrollable = false
        this.offsetWidth = 0
      }
    },
    handlePre() {
      const scroller = this.$refs.scroller
      if (Math.abs(this.offsetWidth) > 0 && Math.abs(this.offsetWidth) >= scroller.offsetWidth) {
        this.offsetWidth += scroller.offsetWidth
      } else {
        this.offsetWidth = 0
      }
    },
    handleNext() {
      const scroller = this.$refs.scroller
      const btnGroup = this.$refs['btn-group']
      const widthDiff = btnGroup.offsetWidth - scroller.offsetWidth
      if (widthDiff > Math.abs(this.offsetWidth)) {
        const offsetDiff = widthDiff - Math.abs(this.offsetWidth)
        if (offsetDiff > scroller.offsetWidth) {
          this.offsetWidth -= scroller.offsetWidth
        } else {
          this.offsetWidth -= offsetDiff
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-button-group-slider {
  overflow: hidden;
  .wrapper {
    position: relative;
    .scroller{
      overflow: hidden;
      .button-group {
        position: relative;
        height: 28px;
        white-space: nowrap;
        display: inline-block;
      }
    }
    &.is-scrollable{
      padding: 0 20px;
      .pre,.next{
        position:absolute;
        cursor: pointer;
        i{
          font-size: 20px;
          line-height: 28px;
          color: $--color-text-secondary;
          &:hover {
            color: $--color-primary;
          }
        }
      }
      .pre {
        left: 0;
      }
      .next {
        right: 0;
      }
    }
  }
}

</style>
